<template>
  <b-modal id="modal-auth" title="实例授权" scrollable v-model="modalShow">
    <b-form-checkbox-group
      v-model="selected"
      :options="items"
      name="flavour-2a"
      stacked
    />
    <template #modal-footer="{ cancel }">
      <b-button size="sm" variant="danger" @click="cancel()">
        取消
      </b-button>
      <b-button size="sm" variant="success" @click="auth">
        提交
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import Error from '@/mixin/error'
import api from '@/utils/api'
import consts from '@/utils/consts'

export default {
  name: 'vote-auth',
  mixins: [Error],
  data () {
    return {
      modalShow: false,
      items: [],
      currentPage: 1,
      perPage: 0,
      selected: [],
      appId: null,
      oversea: null
    }
  },
  methods: {
    show (appId, oversea) {
      this.selected = []
      this.appId = appId
      this.oversea = oversea
      this.getUserList(appId)
      this.modalShow = true
    },
    getUserList (appId) {
      api.fetchListData(this, api.getVoteAdminList(), 'admin_info', { app_id: appId, edition: this.oversea ? consts.OVERSEA_TYPE : process.env.NODE_ENV.slice(0, 3) }, this.handleUserList)
    },
    handleUserList (resData) {
      let items = []
      for (let idx in resData['admin_info']) {
        items.push({
          text: [resData['admin_info'][idx].name, resData['admin_info'][idx].email].join(' | '),
          value: resData['admin_info'][idx].email,
          disabled: resData['admin_info'][idx].is_bd
        })
      }
      this.items = items
    },
    auth () {
      if (this.selected.length === 0) {
        this.$message.error('未选择授权用户')
        return
      }
      let data = {
        email_list: this.selected,
        app_id: this.appId
      }
      api.createVoteData(this, api.getVoteAppFocus(), 'GET', data, this.oversea ? consts.OVERSEA_TYPE : '', this.authCallback, false)
    },
    authCallback () {
      this.$message.info('授权成功')
      this.$bvModal.hide('modal-auth')
      this.$emit('refreshList', this.appId)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// VoteAuth.vue?5110660b